import {Filter} from '@core/interfaces/system/system-common';
import {GeospatialCenterCoordinate} from './viewer-config';
import {VisualizationType} from './visualization';
import {BucketDto} from '../layers/metric-layer';
import {OutageEntityDto} from '../layers/outage-layer';

/*
 * Request DTOs
 */
export class FindGeospatialOutagesRequest {
    visualizationType: VisualizationType;
    metric: string; // not using the defined metric types, such that more can be added w/o code changes
    buckets: string[];
    labelFormat: LabelType;
    filterList: Filter[];
    centerConfig: GeospatialCenterCoordinate;
}
export class FindGeospatialEntitiesRequest {
    visualizationType: VisualizationType;
    measure: string; // not using the defined metric types, such that more can be added w/o code changes
    metric: string; // not using the defined metric types, such that more can be added w/o code changes
    filterList: Filter[];
    buckets: string[];
    centerConfig: GeospatialCenterCoordinate;
}

export class GeospatialSearchAssetRequest {
    assetId: string;
    workflowItemId: number;
}

/*
 * Response DTOs
 */
export class FindGeospatialOutagesResponse {
    visualizationType: VisualizationType;
    data: OutageEntityDto[];
    buckets: BucketDto[];
}
export class FindGeospatialEntitiesResponse {
    visualizationType: VisualizationType;
    data: SpatialEntityData[];
}

export class SpatialEntityData {
    entityId: string;
    entityType: string;
    count?: number;
    colour?: string;
    geoJsonGeometryStr?: string;
    geoJsonGeometry?: GeoJSONGeometry;
    geospatialEntitySymbolType?: GeospatialEntitySymbolType;
}

export class GeoJSONGeometry {
    type: GeoJSONGeometryType;
    coordinates: any[];

    constructor(type: GeoJSONGeometryType, coordinates: any[]) {
        this.type = type;
        this.coordinates = coordinates;
    }
}
export enum GeoJSONGeometryType {
    Point = 'Point',
    LineString = 'LineString',
    MultiLineString = 'MultiLineString',
    Polygon = 'Polygon',
    MultiPolygon = 'MultiPolygon',
}

// Enumerations
export enum LabelType {
    ABSOLUTE = 'ABSOLUTE',
    PERCENTAGE = 'PERCENTAGE',
    BOTH = 'BOTH',
}
export enum GeospatialEntitySymbolType {
    POINT = 'POINT',
    SUBSTATION = 'SUBSTATION',
    NONE = 'NONE',
}
